module.exports = __webpack_public_path__ + "static/media/LapizReport.893ff2fa.png";